import _ from 'lodash';
import LoadingScreen from './../../minimals/LoadingScreen';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { PATH_AUTH, PATH_PAGE } from 'src/routes/paths';
import {
  currentWorkspaceSelectors,
  userSelectors,
  workspaceSelectors,
} from 'src/selectors';

/* 
 TODO: Este guard se creo porque hay logica en el guard de Auth que estaba
 chocando con respecto a la pagina de workspaces, seria oportuno refactorizar
 el guard de Auth pero implicaria varios cambios, de momento esto soluciona
 pero debería cambiarse en un futuro
*/

const WorkspacesPageGuard = ({ children }) => {
  const isAuthenticated = useSelector(userSelectors.isAuth());
  const hasWorkspaces = useSelector(workspaceSelectors.hasWorkspaces);
  const isWorkspaceLoading = useSelector(
    workspaceSelectors.isWorkspaceLoading()
  );
  const currentWorkspaceId = useSelector(
    currentWorkspaceSelectors.getCurrentWorkspaceId()
  );

  const hasWorkspacesInvitations = useSelector(
    workspaceSelectors.hasWorkspacesInvitations
  );

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.root} />;
  }

  if (isWorkspaceLoading) {
    return <LoadingScreen />;
  }

  if (
    !hasWorkspaces &&
    !hasWorkspacesInvitations &&
    _.isEmpty(currentWorkspaceId)
  ) {
    return <Navigate to={PATH_PAGE.createWorkspace} />;
  }

  return <>{children}</>;
};

export default WorkspacesPageGuard;
